import { Link } from "react-router-dom";
import { seriesList } from "@/mocks/series";
import { newsList } from "@/mocks/news";
import { categories } from "@/mocks/categories";

export default function HeroBanner() {
  const stats = [
    { value: `${seriesList.length}+`, label: "AI 短剧作品" },
    { value: `${categories.length}`, label: "内容分类" },
    { value: `${newsList.length}+`, label: "行业资讯" },
  ];

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20futuristic%20digital%20stage%20with%20glowing%20film%20frames%20and%20light%20particles%20floating%20in%20deep%20navy%20space%2C%20warm%20orange%20accent%20beams%2C%20cinematic%20wide%20composition%2C%20high%20detail%20tech%20atmosphere%2C%20dark%20background%20for%20text%20overlay%2C%20no%20text&width=1920&height=1000&seq=aisd-hero-home&orientation=landscape"
          alt="ai短剧 平台视觉背景"
          title="ai短剧 · 人工智能短剧推荐平台"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/85 to-primary-900/55"></div>
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-4 py-16 md:px-8 md:py-24 lg:py-28">
        <div className="max-w-3xl animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-100">
            <i className="ri-sparkling-2-fill text-accent-400"></i>
            人工智能创作的短剧 · 每日更新
          </span>

          <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
            ai短剧
            <span className="mt-2 block text-xl font-semibold text-accent-400 md:text-2xl">
              最新人工智能短剧作品推荐及资讯平台
            </span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-secondary-100 md:text-base">
            聚合丰富的人工智能短剧内容，涵盖科幻、悬疑、古装、动画等多类型创新短视频作品，
            提供最新短剧动态、剧情介绍与创作背景，帮你快速定位下一部想看的好作品。
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/category"
              className="inline-flex items-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-play-list-2-line text-lg"></i>
              <span className="whitespace-nowrap">开始探索短剧</span>
            </Link>
            <Link
              to="/news"
              className="inline-flex items-center gap-2 rounded-md border border-background-50/30 bg-background-50/5 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/15"
            >
              <i className="ri-newspaper-line text-lg"></i>
              <span className="whitespace-nowrap">浏览短剧资讯</span>
            </Link>
          </div>

          <dl className="mt-12 grid max-w-lg grid-cols-3 gap-6">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                  {item.value}
                </dt>
                <dd className="mt-1 text-xs text-secondary-200 md:text-sm">{item.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}